// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3q50T","icon":"SortAdornment_icon__aKbRX","up":"SortAdornment_up__2dn6m","down":"SortAdornment_down__3vdW5","active":"SortAdornment_active__3EZVw"};